export default function getWebServiceCount(){

  for(var i=0; i<10; ++i){
    var wscr = getWebServiceCount_aux();
    if(wscr!==""){
      return wscr;
    }
  }
  return "";
}
function getWebServiceCount_aux(){
  try{
    let length = 8;
    let digits = new Array(length);
    for(let i=0; i<length-1; i++){
    let tmp = (Math.random())*10;
      if(Math.ceil(tmp)>=10){ tmp=(Math.random())*9;}
      if(Math.ceil(tmp)<=0) { tmp=6.0;}
      digits[i] = Math.ceil(tmp);
    }
    let sum = 0;
    let alt = true;
    for(let i = length-2; i >= 0; i--){
      if(alt){
        let temp = digits[i];
        temp *= 2;
        if(temp > 9){
          temp -= 9;
        }
        sum += temp;
      }
      else{
        sum += digits[i];
      }
      alt = !alt;
    }
    let modulo = sum % 10;
    if(modulo > 0){
      digits[length-1] = 10 - modulo;
    }
    let resStr = "";
    for(let i=0; i<length; i++){
     resStr = resStr+digits[i].toString();
    }
    return resStr;
  }catch(err){
    console.log("gwsc err="+err);
  }
  return "";
}
